<template>
  <div class="ColumnHome">
    <!-- <div class="ColumnHomeCommorCont crumbs"><a href="/">Home</a>> Listen Live</div> -->
    <!-- 主要内容（包含左侧和右侧） -->
    <div class="ColumnHomeCommorCont liveSection">
      <!-- 左侧 -->
      <div class="wrap-left">
        <!-- 左侧主要人物大图 -->
        <div class="live-pic">
          <img :src="onAirInfo.programUrl" alt="" />
          <i class="live-pic-play" id="js-live-play" data-id="" data-type="live" :data-title="onAirInfo.title" :data-date="onAirInfo.day" :data-time="onAirInfo.startTime+'-'+onAirInfo.stopTime" :data-announcer="onAirInfo.hostsName" :data-program-title="onAirInfo.programTitle" data-url="http://sk.cri.cn/915.m3u8" @click="LiveBtnplay($event,true)"></i>
        </div>
        <!-- title -->
        <h1 class="live-title">{{onAirInfo.title}}</h1>
        <!-- info -->
        <div class="live-info">
          <span>{{onAirInfo.day}}</span>
          <span>|</span>
          <span>{{onAirInfo.startTime+'-'+onAirInfo.stopTime}}</span>
          <a href="/schedule/detail?programId=252074"
            ><span class="mblue">{{onAirInfo.programTitle}}</span></a
          >
        </div>
        <!-- txt -->
        <div class="live-txt">
          <p>
            {{onAirInfo.programTitle}}
          </p>
        </div>
        <!-- 分享 -->
        <div class="widget-share">
          <strong>分享至：</strong>
          <span class="weixin"></span>
          <span class="weibo"></span>
          <span class="qq"></span>
        </div>

        <!-- 评论相关 -->
        <div class="comment">
          <h2 class="column-title column-title-id" data-programid="1323">
            Featured Comments
          </h2>
          <div class="comment-list">
            <!-- 无list的时候 -->
            <div class="comment-list-item" v-if="comments.length <= 0">
              <p>暂无评论</p>
            </div>

            <!-- list -->
            <div class="comment-list-item" v-for="(item, index) in comments" :key="index" v-else>
              <div class="comment-list-img">
                <img :src="item.userPic" alt=""/>
              </div>
              <div class="comment-list-txt">
                <span class="title">{{item.userName}}</span>
                <p>{{item.content}}</p>
                <div class="info"><span class="time">{{item.createTime}}</span></div>
              </div>
            </div>
            <!-- more -->
            <div class="more" @click="moreComments">more</div>

            <!--  -->
          </div>
        </div>
        <!-- -----=== -->
      </div>

      <!-- 右侧   -->
      <div class="wrap-right live-right">
        <!-- Recently Played -->
        <h2 class="column-title">Recently Played</h2>

        <!-- ===== -->
        <div class="live-list-area clearfix">
          <ul class="live-list" id="js-live-list">
            <li class="current" v-for="(item,key) in historySongs.slice(0,6)" :key="key">
              <span class="time"><i></i>{{item.time}}</span
              ><em class="name">{{item.title}}</em>
              <p class="txt">{{item.artists}}</p>
            </li>
          </ul>
        </div>
        <h2 class="column-title">Previous Episodes</h2>
        <div class="s-list">
          <div class="item" v-for="(item,key) in history.slice(0,5)" :key="key">
            <router-link :to="'/columnList/1/'+item.programId">
              <img :src="item.programUrl" alt=""/>
              <div class="item-r">
                <h4>
                  <a href="javascript:void(0)" class="item-trigger" data-id="" data-type="mp3" :data-title="item.programTitle" :data-date="item.day" :data-time="item.time" :data-img="item.programUrl" data-announcer="" :data-url="item.mediaUrl">{{item.title}}</a>
                </h4>
                <span class="time">{{item.day}} {{item.time}}</span>
                <span style="position: relative;line-height: 1.7em;max-height: 3.4em;overflow: hidden;">{{item.detail}}</span>
                <!-- <span class="name">方舟 李源</span> -->
              </div>
            </router-link>
            
          </div>
        </div>
      </div>
    </div>

    <!-- wrap -->

    <div class="ColumnHomeCommorCont wrap">
      <ul class="live-hosts-list">
        <li v-for="(item, index) in hosts" :key="index">
          <a href="/hosts/detail?hostId=69">
            <span class="hosts-photo">
              <img
                :src="item.hostUrl+'?x-oss-process=image/resize,m_fill,w_200,h_200,limit_0'"
                alt=""
              />
            </span>
            <span class="hosts-name">{{item.hostName}}</span>
          </a>
          <p class="hosts-txt">
            《Music Matters》节目主持人
            从音乐学院到电台DJ，从古典到流行，从听到说，在声音的世界中慢慢沉淀自我。
            理解生活与理解音乐一样有趣，生活就该有趣更有聊。
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ColumnHome",
  data() {
    return {
      onAirInfo:{},
      hosts:[],
      history:[],
      comments:[],
      historySongs:[],
      page:1,
      curId:0,
    };
  },
  methods:{
    getLiveData:function(){
      var _this = this;
      _this.$http.post('/qertyuiy/v3/live?session=8295f0a6-6804-4d61-8944-4f8d60a71cd4')
      .then(async function(res){    
        var onAir = res.data.onair , radioList = res.data.data , hostsData = res.data.onair.hosts;
        onAir.startTime = onAir.startTime.substring(0,5) , onAir.stopTime = onAir.stopTime.substring(0,5);
        onAir.hostsName = '';
        for(var i=0;i<hostsData.length;i++){
          onAir.hostsName += hostsData[i].hostName+' ';
        }
        _this.onAirInfo = onAir;
        _this.hosts = hostsData;
        _this.curId = res.data.onair.id;
        _this.getHistorySongs(_this.curId);
        _this.getComments(_this.curId,false);
      })
      .catch(function(e){

      })
    },
    getHistoryData:function(){
      var _this = this;
      _this.$http.post('/qertyuiy/program/onAir?programId=0&type=oth')
      .then(async function(res){    
        if(res.data.data.history != undefined){
          var historyData = res.data.data.history;
          _this.history = historyData;
        }
      })
      .catch(function(e){

      })
    },
    getComments:function(id,isMore){
      var _this = this , _id = id , _isMore = isMore;
      _this.$http.get('/qertyuiy/v2/message?origin=ezfm&episodeId='+_id+'&page='+_this.page+'&pageSize=5')
      .then(async function(res){    
        var commentsData = res.data.episodeMessage , newArr = [];
        if(_isMore == true){//点击触发的
          newArr = _this.comments.concat(commentsData);
          _this.comments = newArr;
        }else{//页面首次加载
          _this.comments = commentsData;
        }
      })
      .catch(function(e){

      })
    },
    getHistorySongs:function(id){
      var _this = this , _id = id;
      _this.$http.get('/qertyuiy/monitoring/historyList?id='+_id+'&type=episode&session=8295f0a6-6804-4d61-8944-4f8d60a71cd4')
      .then(async function(res){    
        var songsData = res.data.data , time;
        for(var i=0;i<songsData.length;i++){
          time = songsData[i].time.split(' ')[1];
          songsData[i].time = time.substring(0,5);
        }
        _this.historySongs = songsData.reverse();
      })
      .catch(function(e){

      })
    },
    moreComments:function(){
      var _this = this;
      _this.page+=1;
      _this.getComments(_this.curId,true);
    },
    LiveBtnplay:function(event,type){
      var _this = this , _el = $(event.currentTarget) , _curPage = $(_this.$parent.$children[3].$el) , _type = type;
      if(_curPage.attr('class') != 'player'){
        _this.$parent.$children[2].audioPlay(_el, _type);
      }else{
        _this.$parent.$children[3].audioPlay(_el, _type);
      }
    },
  },
  mounted:function(){
    this.getLiveData();
    this.getHistoryData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
* {padding: 0; margin: 0;}
a {cursor: pointer;}

ul,ol {list-style: none;list-style-image: none;}
li {display: list-item;text-align: -webkit-match-parent;}
i {font-style: italic;}
img {border: 0;}
body,html {font-family: "Microsoft YaHei", sans-serif;width: 100%;height: 100%;}
.clearfix {zoom: 1;display: block;}
.clearfix:after {content: ".";display: block;height: 0;clear: both;visibility: hidden;}

.ColumnHome {background: #f3f4f5;}
.ColumnHomeCommorCont {width: 1280px;margin: 0 auto;}
// 导航栏
.crumbs {font-size: 14px;color: #999;height: 64px;line-height: 54px;
  a {font-size: 14px;color: #999;}
}
//主要内容

.liveSection {
  display: flex;
  margin-top: 30px;
  // 左侧
  .wrap-left {width: 784px;
    // 最大图
    .live-pic {position: relative;width: 780px;height: 520px;margin: 0 auto;
      img {width: 100%;display: block;height: 100%;}
      i.live-pic-play {background: url("../../static/img/sprite-icon.png");cursor: pointer;position: absolute;left: 50%;top: 50%;width: 76px;height: 76px;margin-left: -38px;margin-top: -38px;background-position: -150px -80px;background-size: auto;}
    }
    // title
    .live-title {margin-top: 20px;font-size: 24px;font-weight: normal;font-weight: normal;margin-block-start: 0.67em;margin-block-end: 0.67em;margin-inline-start: 0px;margin-inline-end: 0px;}
    //  -- info -

    .live-info {margin-top: 10px;color: #999;
      span {padding-right: 10px;}
      span.mblue {color: #0085cc;}
    }
    // txt
    .live-txt {font-size: 14px;color: #333;
      p {padding: 10px 0;}
    }
    // 分享
    .widget-share {display: flex;height: 21px;line-height: 21px;margin-top: 14px;
      strong {padding-right: 30px;font-weight: normal;color: #999;font-size: 14px;}
      span {cursor: pointer;width: 25px;height: 21px;margin-right: 15px;background: url("../../static/img/sprite-icon.png");}
      span.weixin {background-position: -300px 0px;}
      span.weixin:hover {background-position: -300px -30px;}
      span.weibo {background-position: -329px 0px;}
      span.weibo:hover {background-position: -329px -30px;}
      span.qq {background-position: -359px 0px;}
      span.qq:hover {background-position: -359px -30px;}
    }
    //
    //评论相关
    .comment {margin-top: 34px;padding: 30px 0 0 0;border-top: solid 1px #dcdee3;
      .column-title {font-size: 28px;margin: 0;position: relative;padding-left: 10px;line-height: 30px;color: #000;font-style: normal;font-weight: normal;
      }
      .column-title:before {
        position: absolute;
        left: 0;
        top: 5px;
        display: block;
        content: "";
        width: 5px;
        height: 20px;
        border-radius: 2px;
        overflow: hidden;
        background-color: #f58431;
      }

      //@at-rootcomment-list
      .comment-list {
        padding: 0;
        // 无list 时候p的样式
        .comment-list-item {
          padding-top: 20px;
          border-top: dashed 1px #dcdee3;
          margin-top: 20px;

          //--
          .comment-list-img {
            width: 70px;
            height: 70px;
            float: left;
            overflow: hidden;
            border-radius: 50%;
            img {
              width: 70px;
              height: 70px;
              display: block;
            }
          }
          // ---有评论list
          .comment-list-txt {
            margin-left: 100px;
            .title {
              display: block;
              font-size: 18px;
              color: #666;
              margin-bottom: 10px;
            }
            p {
              font-size: 14px;
              line-height: 2em;
            }
            .info {
              margin-top: 14px;
              height: 22px;
              line-height: 22px;
              font-size: 14px;
              .time {
                float: right;
                color: #999;
              }
            }
          }
        }
        // --- 更多 btn
        .more {
          width: 134px;
          height: 52px;
          margin: 20px auto 0;
          border-radius: 5px;
          line-height: 52px;
          font-size: 14px;
          background-color: #31a9de;
          color: #fff;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    // -----有列表
  }
  // 右侧
  .wrap-right {
    width: 464px;
    margin-left: 32px;
    // Recently Played h2

    .live-list-area {
      height: auto;
      overflow: visible;
      position: relative;
    }
    .clearfix:after {
      content: ".";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .column-title {
      font-size: 28px;
      margin: 0;
      position: relative;

      padding-left: 10px;

      line-height: 30px;
      color: #000;
      font-style: normal;
      font-weight: normal;
    }
    .column-title:before {
      position: absolute;
      left: 0;
      top: 5px;
      display: block;
      content: "";
      width: 5px;
      height: 20px;
      border-radius: 2px;
      overflow: hidden;
      background-color: #f58431;
    }
    // 直播时间
    .live-list {
      position: static;
      margin-top: 40px;
      border-left: solid 1px #dcdee3;
      border-top: none;
      left: 0;
      top: 0;
      // li
      li {
        float: none;
        width: auto;
        height: auto;
        padding: 0;

        padding-left: 90px;
        margin-bottom: 40px;
        position: relative;
        // 时间
        .time {
          position: absolute;
          left: -7px;
          top: 0;
          width: auto;
          height: auto;
          font-size: 16px;
          color: #999;
          line-height: 16px;

          overflow: hidden;
          i {
            background-color: #dcdee3;
            margin: 0 auto;
            margin-right: 10px;
            margin-top: 1px;
            float: left;
            display: block;
            width: 11px;
            height: 11px;

            border: solid 1px #0085cc;
            border-radius: 50%;
            overflow: hidden;
          }
        }
        //
        .name {
          display: block;
          font-size: 24px;
          line-height: 24px;
          height: auto;
          height: auto;
          color: #0085cc;
          font-style: normal;
          overflow: hidden;
        }

        // ---
        .txt {
          font-size: 24px;
          line-height: 24px;
          height: auto;
          color: #999;
          display: block;
        }
      }
    }

    //@at-root
    .s-list {
      margin-top: 10px;
    }
    .item {
      height: 136px;
      margin-top: 20px;
      padding-bottom: 10px;
      overflow: hidden;
      //左侧大图
      img {
        width: 203px;
        height: 136px;
        display: block;
        float: left;
        border: 0;
      }
      // 右侧 div 。item-r
      .item-r {
        margin-left: 220px;
        line-height: 2em;
        font-size: 14px;
        h4 {
          max-height: 4em;
          overflow: hidden;
          margin-bottom: 5px;
          a:hover{color: #0085cb;}
        }
        span {
          display: block;
          color: #999;
        }
        span.name {
          color: #999;
        }
        span.time {
          display: block;
        }
      }
    }
  }
}

// wrap list
.wrap {
  margin: 10px auto 0;
  .live-hosts-list {
    margin: 0;
    display: block;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      width: auto;
      min-width: auto;
      padding: 25px 0;
      height: 214px;
      border-bottom: dashed 1px #dcdee3;
      .hosts-photo {
        display: block;
        width: 214px;
        height: 214px;
        float: left;

        margin: 0 auto;
        margin-right: 50px;
        overflow: hidden;
        border-radius: 50%;
        img {
          display: block;
          width: 100%;
        }
      }
      .hosts-name {
        display: block;
        margin-top: 0;
        margin-bottom: 0;
        text-align: left;
        font-size: 18px;
        color: #666;
      }

      a {
        color: #333;
        text-decoration: none;
        background: transparent;
      }
      .hosts-txt {
        display: block;
        font-size: 14px;
        line-height: 42px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
// 移动端适配

@media screen and (max-width: 900px) {
  * {
    box-sizing: border-box;
  }
  .ColumnHome {
    .crumbs {
      display: none;
    }
  }
  .liveSection {
    width: 100%;
    display: block;
    margin-top: .3rem;
    .wrap-left {
      width: 100%;
      //  主图
      .live-pic {
        position: relative;
        width: 100%;
         height:auto;
        
        img {
          width: 100%;
          height:auto;
          display: block;
        }
      }
      // live-title
      .live-title {
        margin-top: 20px;
        font-size: 24px;
      }
      //
      .live-info {
        margin-top: 10px;
        color: #999;

        display: flex;
        span {
          font-size: 0.24rem;
          padding-right: 10px;
          display: block;
          line-height: 0.3rem;
        }
        a {
          span {
            padding: 0;
          }
        }
      }

      .comment {
        margin-top: 14px;
        border-top: solid 1px #dcdee3;
        padding: 10px 0 0 0;
        //
        .column-title {
          position: relative;
          margin: 0 10px;
          padding-left: 10px;
          font-size: 14px;
          line-height: 30px;
          color: #000;
          font-style: normal;
          font-weight: normal;
        }
        .comment-list-item {
          font-size: 0.24rem;
        }
        // list
        .comment-list {
          padding: 0 10px;
          .comment-list-item {
            padding-top: 20px;
            border-top: dashed 1px #dcdee3;
            margin-top: 20px;
            .comment-list-img {
              width: 34px;
              height: 34px;
              float: left;
              overflow: hidden;
              border-radius: 50%;
              img {
                width: 34px;
                height: 34px;
                display: block;
              }
            }
            //右侧
            .comment-list-txt {
              margin-left: 50px;

              .title {
                display: block;
                font-size: 18px;
                color: #666;
                margin-bottom: 10px;
              }
              p {
                font-size: 14px;
                line-height: 2em;
              }
              .info {
                margin-top: 14px;
                height: 22px;
                line-height: 22px;
                font-size: 14px;
                .time {
                  float: right;
                  color: #999;
                }
              }
            }
          }
        }
      }
    }
    .wrap-right {
      width: 100%;
      margin-left: 0px;
      .column-title {
        position: relative;
        margin: 0 10px;
        padding-left: 10px;
        font-size: 14px;
        line-height: 30px;
        color: #000;
        font-style: normal;
        font-weight: normal;
      }
      .live-list-area {
        position: relative;
        overflow: hidden;
        overflow-x: scroll;
        height: 90px;
        .live-list {
          position: absolute;
          left: 0;
          top: 0;
          margin-top: 20px;
          border-top: solid 1px #dcdee3;

          li {
            position: relative;
            float: left;
            width: 100px;
            padding: 15px 10px 0;
            height: 52px;

            display: list-item;
            text-align: -webkit-match-parent;
            .time {
              position: absolute;
              // left:0px;
              left: 26px;
              top: -7px;
              width: 40%;
              height: 13px;
              color: #999;
              overflow: hidden;
              text-align: center;
              line-height: 14px;
            }
            .name {
              font-size: 12px;
              color: #0085cc;
              font-style: normal;
              height: 14px;
              overflow: hidden;
              display: block;
              line-height: 14px;
            }
            .txt {
              font-size: 12px;
              color: #999;
              height: 28px;
              overflow: hidden;
              display: block;
              line-height: 14px;
            }
          }
        }
      }

      // ---
      .s-list {
        .item {
          height: 100px;
          margin-top: 10px;
          padding-bottom: 10px;
          overflow: hidden;
          img {
            display: block;
            float: left;
            width: 150px;
            height: 100px;
          }
          .item-r {
            margin-left: 170px;
            font-size: 14px;
            line-height: 1.5em;

            h4 {
              max-height: 4.5em;
              overflow: hidden;
              margin-bottom: 5px;
            }
            span {
              display: none;
            }
            span.time {
              display: block;
            }
          }
        }
      }
      // ----
    }
  }
  // wrap
  .wrap {
    margin-top: .5rem;
    width: 100%;
    .live-hosts-list {
      margin: 10px 10px 0;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 30%;
        min-width: 90px;
        padding: 0;
        height: auto;
        border-bottom: none;
        a {
          display: flex;
          flex-direction: column;
          color: #333;
          text-decoration: none;
          // display: block;
          .hosts-photo {
            display: block;
            width: 90px;
            height: 90px;
            margin: 0 auto;
            overflow: hidden;
            border-radius: 50%;
            img {
              display: block;
              width: 100%;
            }
          }
          .hosts-name {
            display: block;
            margin-top: 5px;
            margin-bottom: 10px;
            text-align: center;
            font-size: 18px;
          }
        }
        // --
        .hosts-txt {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/ColumnHome.vue